module.exports = __webpack_public_path__ + "static/media/burger_only_centered_trimmed_logo.aafa9a23.png";